import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  Checkbox,
} from "@mui/material";
import { t } from "i18next";
import { CATEGORY_CODE } from "../../constants/enums";
import { primaryColor } from "../../constants/colorConstants";
import { getPcmMappings } from "../../services/emissionService";

const EmissionDetailedViewDialog = (props: any) => {
  const {
    open,
    onClose,
    year,
    emissionData,
    targetScope,
    targetCoverage,
    targetType,
    categoryList,
    handleTableCellClick,
  } = props;

  let [pcmData, setPcmData] = useState<any>([]);

  useEffect(() => {
    getPcmMappings().then((res) => {
      let mappings = res.data;
      setPcmData(mappings);
    });
  }, []);

  const [cellColumns, setCellColumns] = useState<string[]>([]);

  const baselineColumns = [
    "Baseline year",
    "Emissions(tCO2e)",
    "Included",
    "",
    "Comments",
  ];

  const mostRecentColumns = [
    "Most Recent year",
    "Emissions(tCO2e)",
    "",
    "Comments",
  ];

  const targetColumns = ["Target year", "Emissions(tCO2e)", "%SBT reduction"];

  const updateCellColumns = (targetType: string) => {
    switch (targetType) {
      case "BASELINE":
        setCellColumns(baselineColumns);
        break;
      case "MOST RECENT":
        setCellColumns(mostRecentColumns);
        break;
      case "TARGET":
        setCellColumns(targetColumns);
        break;
      default:
        console.error(`Unknown target type: ${targetType}`);
        setCellColumns([]);
        break;
    }
  };

  useEffect(() => {
    updateCellColumns(targetType);
  }, [targetType]);

  console.log(year, "year");

  console.log(emissionData, "emissionData");

  const allowCategory = (code: CATEGORY_CODE) => {
    if (targetType === "MOST RECENT") {
      return true;
    } else if (
      targetScope === 1 &&
      targetCoverage === "Separate Targets for Scope 1, Scope 2 and Scope 3"
    ) {
      return (
        code >= CATEGORY_CODE.CATEGORY_1_1 && code < CATEGORY_CODE.CATEGORY_2_1
      );
    } else if (targetScope === 2) {
      return (
        code >= CATEGORY_CODE.CATEGORY_2_1 && code < CATEGORY_CODE.CATEGORY_3_1
      );
    } else if (targetScope === 3) {
      return code >= CATEGORY_CODE.CATEGORY_3_1;
    } else if (
      targetCoverage ===
      "Common Target for Scope 1 & 2; Separate Target for Scope 3"
    ) {
      return (
        code >= CATEGORY_CODE.CATEGORY_1_1 && code < CATEGORY_CODE.CATEGORY_3_1
      );
    }
    return true;
  };

  emissionData.sort((a: { category: number }, b: { category: number }) => {
    if (a.category > b.category) return 1;
    if (a.category < b.category) return -1;
    return 0;
  });

  const scopeValues = {
    scope1: 0,
    scope2: 0,
    scope3: 0,
  };

  const sbtValues = {
    scope1: 0,
    scope2: 0,
    scope3: 0,
  };

  emissionData.forEach(
    (category: {
      scope: number;
      value: number;
      reduction_percentage?: number;
      is_included: boolean;
    }) => {
      if (category.scope === 1 && category.is_included) {
        scopeValues.scope1 += category.value;
        if (
          targetType === "TARGET" &&
          category.reduction_percentage !== undefined &&
          category.reduction_percentage !== 0
        ) {
          sbtValues.scope1 = category.reduction_percentage;
        }
      } else if (category.scope === 2 && category.is_included) {
        scopeValues.scope2 += category.value;
        if (
          targetType === "TARGET" &&
          category.reduction_percentage !== undefined &&
          category.reduction_percentage !== 0
        ) {
          sbtValues.scope2 = category.reduction_percentage;
        }
      } else if (category.scope === 3 && category.is_included) {
        scopeValues.scope3 += category.value;
        if (
          targetType === "TARGET" &&
          category.reduction_percentage !== undefined &&
          category.reduction_percentage !== 0
        ) {
          sbtValues.scope3 = category.reduction_percentage;
        }
      }
    }
  );

  let totalEmissionValue =
    scopeValues.scope1 + scopeValues.scope2 + scopeValues.scope3;
  let totalSbtValue = sbtValues.scope1; //+ sbtValues.scope2 + sbtValues.scope3;

  const renderCategoryRows = () => {
    let protocol = localStorage.getItem("protocol");
    return categoryList
      .filter((eachCategory: any) => allowCategory(eachCategory.code))
      .map((eachCategory: any) => {
        if (protocol == "ghg") {
          let mapping = pcmData.filter((item: any) => item.ghg == eachCategory);
          eachCategory.id = mapping[0].iso;
        }
        const matchedCategory = emissionData.find(
          (cat: { category: number; is_included: boolean }) =>
            cat.category === eachCategory.id
        );
        console.log(matchedCategory, "matchedCategory");
        const isMatched =
          matchedCategory?.category === eachCategory.id &&
          matchedCategory?.is_included;

        return (
          <React.Fragment key={eachCategory.id}>
            {eachCategory?.code === CATEGORY_CODE.CATEGORY_1_1 && (
              <TableRow>
                <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
                  Scope 1 :
                </TableCell>
                <TableCell className="bg-info-100" align="right">
                  {scopeValues.scope1}
                </TableCell>
                {targetType === "TARGET" ? (
                  <TableCell className="bg-info-100" align="right">
                    {sbtValues.scope1}
                  </TableCell>
                ) : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ? null : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ||
                targetType === "MOST RECENT" ? null : (
                  <TableCell className="bg-info-100" />
                )}
              </TableRow>
            )}
            {eachCategory?.code === CATEGORY_CODE.CATEGORY_2_1 && (
              <TableRow>
                <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
                  Scope 2 :
                </TableCell>
                <TableCell className="bg-info-100" align="right">
                  {scopeValues.scope2}
                </TableCell>
                {targetType === "TARGET" ? (
                  <TableCell className="bg-info-100" align="right">
                    {sbtValues.scope2}
                  </TableCell>
                ) : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ? null : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ||
                targetType === "MOST RECENT" ? null : (
                  <TableCell className="bg-info-100" />
                )}
              </TableRow>
            )}
            {eachCategory?.code === CATEGORY_CODE.CATEGORY_3_1 && (
              <TableRow>
                <TableCell className="bg-info-100 text-slate-700 text-sm font-bold font-['Proxima Nova'] pt-3 pb-2">
                  Scope 3 :
                </TableCell>
                <TableCell className="bg-info-100" align="right">
                  {scopeValues.scope3}
                </TableCell>
                {targetType === "TARGET" ? (
                  <TableCell className="bg-info-100" align="right">
                    {sbtValues.scope3}
                  </TableCell>
                ) : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ? null : (
                  <TableCell className="bg-info-100" />
                )}
                {targetType === "TARGET" ||
                targetType === "MOST RECENT" ? null : (
                  <TableCell className="bg-info-100" />
                )}
              </TableRow>
            )}
            <TableRow>
              <TableCell className={isMatched ? "" : "bg-neutral-400"}>
                {eachCategory?.code} - {eachCategory?.name}
              </TableCell>
              <TableCell
                className={isMatched ? "bg-total-row" : "bg-neutral-400"}
                align="right"
              >
                {matchedCategory?.value || 0}
              </TableCell>
              {targetType === "MOST RECENT" ? null : (
                <TableCell
                  className={isMatched ? "" : "bg-neutral-400"}
                  align={targetType === "BASELINE" ? "center" : "right"}
                >
                  {targetType === "BASELINE" ? (
                    <Checkbox
                      checked={matchedCategory?.is_included}
                      disabled
                      sx={{
                        color: "#8897AE",
                        "&.Mui-checked": { color: primaryColor },
                      }}
                    />
                  ) : (
                    matchedCategory?.reduction_percentage || 0
                  )}
                </TableCell>
              )}
              {targetType === "TARGET" ? null : (
                <TableCell className={isMatched ? "" : "bg-neutral-400"}>
                  <img
                    src="assets/icons/FileUpload.svg"
                    alt="Upload"
                    onClick={
                      matchedCategory?.attachments.files
                        ? () =>
                            handleTableCellClick(
                              matchedCategory?.attachments.files || []
                            )
                        : undefined
                    }
                  />
                  {matchedCategory?.attachments.files &&
                  matchedCategory?.attachments.files.length > 0 ? (
                    <sup className=" text-xs bg-primary badge">
                      {matchedCategory?.attachments.files?.length}
                    </sup>
                  ) : (
                    ""
                  )}
                </TableCell>
              )}
              {targetType === "TARGET" ? null : (
                <TableCell className={isMatched ? "" : "bg-neutral-400"}>
                  {matchedCategory?.comments}
                </TableCell>
              )}
            </TableRow>
          </React.Fragment>
        );
      });
  };

  return (
    <Dialog open={open} className="pw-target-dialog">
      <div className="dialog-content">
        <div className="dialog-header">
          <div>
            {targetType === "BASELINE"
              ? "Baseline Year details"
              : targetType === "TARGET"
              ? "Target Year details"
              : "Most Recent Year details"}
          </div>
          <div onClick={onClose} className="close-icon">
            <CloseIcon />
          </div>
        </div>
        <div className="dialog-body">
          <Card>
            <Table size="small" className="pw-activity-table">
              <TableHead className="pw-activity-table-head">
                <TableRow>
                  {cellColumns.map((eachCell, index) => (
                    <TableCell
                      key={index}
                      className={`pw-activity-list ${
                        targetType === "BASELINE"
                          ? index === 0
                            ? "w-[513px]"
                            : index === 1
                            ? " w-[124px] bg-total-row"
                            : index === 2
                            ? "w-[78px]"
                            : index === 3
                            ? "w-[50px]"
                            : " w-[203px]"
                          : targetType === "TARGET"
                          ? index === 0
                            ? "w-[658px]"
                            : index === 1
                            ? " w-[91px] bg-total-row"
                            : index === 2
                            ? "w-[157px] bg-total-row"
                            : " w-[250px]"
                          : index === 0
                          ? "w-[625px]"
                          : index === 1
                          ? " w-[91px] bg-total-row"
                          : index === 2
                          ? "w-[50px]"
                          : " w-[250px]"
                      }`}
                      align={index === 1 ? "center" : "left"}
                    >
                      {t(eachCell)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className="bg-info-100">{year}</TableCell>
                  <TableCell className="bg-info-100" align="right">
                    {totalEmissionValue}
                  </TableCell>
                  {targetType === "TARGET" ? (
                    <TableCell className="bg-info-100" align="right">
                      {totalSbtValue}
                    </TableCell>
                  ) : (
                    <TableCell className="bg-info-100" />
                  )}
                  {targetType === "TARGET" ? null : (
                    <TableCell className="bg-info-100" />
                  )}
                  {targetType === "TARGET" ||
                  targetType === "MOST RECENT" ? null : (
                    <TableCell className="bg-info-100" />
                  )}
                </TableRow>
                {pcmData.length && renderCategoryRows()}
              </TableBody>
            </Table>
          </Card>
        </div>
      </div>
    </Dialog>
  );
};

export default EmissionDetailedViewDialog;
